module.exports = __webpack_public_path__ + "media/images/gray-3efa894f37e532dabbac577a8c6f20b1.png";